<template>
  <div class="rating">
    <span
      class="rating__item"
      v-for="index in 5"
      :key="'rating_' + index"
      :class="{ 'is-rated': index <= rating }"
    ></span>
  </div>
</template>
<script>
  export default {
    props: ['rating']
  }
</script>



// WEBPACK FOOTER //
// RatingStars.vue?75295e67